<template>
  <div>
    <my-header />
    <div class="privacy-content">
      <h2>Privacy Policy</h2>
      <div class="text-underline"></div>
      <div class="content">
        <p>Hi, welcome to use Trigirls Studio service! This policy aims to help you know about why and what we will collect your information, how you can check or delete information during our service.
        </p>
        <p>
          Attention: if you are still under 16 years old, before you use our service, please make sure that you and your guardian(legal guardian) read this privacy policy together, and the guardian accedes to your action of using our service. </p>
        <p>
          First, we will provide you with service as following, but not limited to: </p>
        <p>
          1, Create account
        </p>
        <p>
          2, Entertainment in game
        </p>
        <p>
          3, Top up service
        </p>
        <p>
          Second, the information we will collect is aiming to provide better service. So we hope you can know about what information will be collected and why we have to do this when you are enjoying our service:
        </p>
        <p>
          1,When creating account, you need to provide personal information, which include: account (If you login with third party account, such as Facebook and google, we will get your authorization to login)passworddevice idIPemail address, these information will be used to provide customized service for you, and the account will help record the items&state belong to you, and will also provide you with account security service such as account binding&find account back.
        </p>
        <p>
          2,During using service, after your consent, we will collect the information, which include: account(If you login with third party account, such as Facebook and google, we will get your consent to login) passworddevice idIPemail address, this information will be used to provide customized service for you, and the account will help record the items&state belong to you, and will also provide you with account security service such as binding&find account back and game activity.
        </p>
        <p>
          All the information mentioned above, will be collected and stored by us, and will not pass to the third party for other uses.
        </p>
        <p>
          Unless you consent to the information collection, we will not collect it.
        </p>
        <p>
          Third, we collect the information mentioned above is basing on the original intention to provide game service. You have the sole rights to refuse it, but it may cause we cannot provide you a complete and better services.
        </p>
        <p>
          Four, you have the sole rights to view and delete your information data:
        </p>
        <p>
          1, You have the sole rights to get contact with our customer service, view the data we collected. If you think the information is wrong or unsuitable, you can require to modify it.
        </p>
        <p>
          2, You have the sole rights to click the [delete account] button to delete information. After delete action, we will not store it anymore, so the next time when you use our service, you may need to Reauthorize our action to provide service.
        </p>
        <p>
          For your convenience to enjoy our service, if you didn’t require to delete it, we will store the information.
        </p>
        <p>
          Five, we build in security function in our service to protect your information and data.
        </p>
        <p>
          1,We use Encryption Technology to make sure that your personal information and data keep secret and will not be exposed during data transfer.

        </p>
        <p>
          2, We review the way we collect&store&processing data from time to time to make sure that Unknow personnel is forbidden to get access to the system.
        </p>
        <p>
          3, Only the specific staff with the pure purpose to deal with information data gets the access. And the specific staff who has the access must comply with Strict confidentiality obligation. If breach it, the staff will be punished.
        </p>
        <p>
          We hope that you have read the policy carefully, and make sure if you are consent to the service we provide comply with the policy above.
        </p>
      </div>
    </div>
    <my-footer />
  </div>
</template>
<script>
import selectArea from '../../../common/components/selectArea_m.vue';
import SelectMeau from '../../../common/components/meau_m.vue';
import MyFooter from '../../../common/components/footer_m.vue';
import MyHeader from '../../../common/components/index_header_m.vue';
export default {
  name: 'privacy_m',
  data() {
    return {
      areaNick: '台湾',
      areaName: '',
      user_name: 'ID0079',
      isShow: false,
      isShowArea: false,
      isShowMenu: false,
      lang: localStorage.getItem('lang') || this.$i18n.locale
    };
  },
  mounted() {

  },
  methods: {

  },
  components: {
    selectArea,
    SelectMeau,
    MyFooter,
    MyHeader
  }
};
</script>
<style lang="less">
@mainColor: #fd6b00;
.header {
  height: 1rem;
  padding: 0 0.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header-left {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.18rem;
    color: @mainColor;
    img {
      height: 0.72rem;
      width: auto;
    }
    .iconfont {
      font-size: 0.06rem;
      margin-left: 0.09rem;
    }
    .selectArea {
      margin-left: 0.2rem;
      padding: 0.06rem 0.1rem;
      border: 1px solid @mainColor;
      border-radius: 0.05rem;
      display: flex;
      align-items: center;
    }
  }
  .header-right {
    display: flex;
    font-size: 0.17rem;
    justify-content: center;
    align-items: center;
    .icon-name {
      color: @mainColor;
    }
    .header-icon {
      margin-left: 0.3rem;
    }
    i {
      font-size: 0.3rem;
      color: @mainColor;
    }
  }
}
.privacy-content {
  min-height: 72vh;
  padding: 0.4rem 0.3rem;
  h2 {
    background: linear-gradient(to bottom, #fe9a3d, #fd6b00);
    -webkit-background-clip: text;
    color: transparent;
    text-align: center;
    font-size: 0.36rem;
  }
  .text-underline {
    width: 0.3rem;
    height: 0.05rem;
    background-color: @mainColor;
    margin: 0.1rem auto 0.2rem;
  }
  p {
    font-size: 0.18rem;
    margin-top: 0.2rem;
    line-height: 0.24rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/module/privacy_m/components/index.vue